import request from '@/utils/http';
import { getSession, setSession } from '@/utils/storage';
import store from '@/store/index';

const TENANT_CODE = store.state.currentTenant.tenantCode;

function getDictCache(keysStr) {
    if (!keysStr) {
        return {
            result: {},
            passKeys: ''
        };
    }
    const keys = keysStr.split(',');
    const result = {};
    const passKeys = [];
    keys.forEach(key => {
        const val = getSession(key);
        if (val) {
            result[key] = val;
        } else {
            passKeys.push(key);
        }
    });
    return {
        result,
        passKeys: passKeys.join(',')
    };
}
function setDictCache(map) {
    Object.keys(map).forEach(key => {
        setSession(key, map[key]);
    });
}

// 库区列表
export const getList = {
    post(url, params) {
        return request({
            url: url + '/userIndividualConfigs/saveOrUpdate',
            method: 'post',
            data: params
        });
    },
    get(url, params) {
        return request({
            url: url + '/userIndividualConfigs/param',
            method: 'post',
            data: params
        });
    }
};

// 字典值
export const dict = (popPrefix, params, tenantCode = '') => {
    const type = Object.prototype.toString.call(params);
    let dictCodes = null;
    if (type === '[object String]') {
        dictCodes = params;
    } else {
        dictCodes = params.dictCodes;
    }
    const data = getDictCache(dictCodes);
    if (data.passKeys === '') {
        return new Promise(resolve => {
            resolve({
                code: '0',
                data: data.result
            });
        });
    } else {
        const params = { dictCodes: data.passKeys };
        if (tenantCode) params.tenantCode = tenantCode;
        return request({
            url: popPrefix,
            method: 'get',
            params: params
        }).then(res => {
            setDictCache(res.data);
            res.data = { ...data.result, ...res.data };
            return res;
        });
    }
};
export const dictWithUrl = (params, tenantCode = '') => {
    return dict('/api-mdm/dictionaryDetail/dict', params, TENANT_CODE);
};

// 远程搜索
export const longRange = (longPrefix, params) => {
    return request({
        url: longPrefix,
        method: 'post',
        data: params
    }).then(res => res);
};
